import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad menas med 'god vandel' i alkohollagen?";
const SHORT_ANSWER = "Vandel = leverne. Du ska ha ett ordnat liv utan relevant brottslighet, allvarliga ekonomiska oegentligheter eller missbruksproblematik.";

export const Route = createFileRoute("/fraga/vad-ar-vandel")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad menas med 'god vandel' i alkohollagen" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Tidigare ekobrott, narkotikabrott och våldsbrott är de vanligaste hindren. Polisens utdrag och Skatteverkets uppgifter ligger till grund. Lindrigare brott långt tillbaka väger normalt inte tungt."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "Vandel och lämplighetsprövning" }}
      related={[{"to": "/fraga/far-jag-tillstand-med-skatteskuld", "label": "Kan jag få serveringstillstånd om jag har skatteskuld?"}, {"to": "/fraga/far-jag-tillstand-med-tidigare-domar", "label": "Får jag serveringstillstånd om jag har tidigare domar?"}, {"to": "/fraga/nar-bedoms-ekonomisk-lamplighet", "label": "Hur bedöms ekonomisk lämplighet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad menas med 'god vandel' i alkohollagen?" },
      { name: "description", content: "Vandel = leverne. Du ska ha ett ordnat liv utan relevant brottslighet, allvarliga ekonomiska oegentligheter eller missbruksproblematik." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-vandel" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-vandel" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-vandel",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad menas med 'god vandel' i alkohollagen", url: "https://alkoholprovet.se/fraga/vad-ar-vandel" },
      ]),
    ],
  }),
});
